import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";

import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate} from "react-router-dom";
import {RiListCheck3} from "react-icons/ri";
import Select from "react-select";
import "react-multi-date-picker/styles/layouts/mobile.css"
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"




function ReturnOrders() {

    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [orders, setOrders] = React.useState([]);
    const [status, ] = React.useState( null);
    const [selectOptions, setSelectOptions] = React.useState([]);
    const [selectedOptions, setSelectedOptions] = React.useState([]);
    const [dateFrom, setDateFrom] = React.useState( null);
    const [dateTo, setDateTo] = React.useState( null);



    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }

        const fromMonth = dateFrom?.toDate?.().getMonth() -(-1);
        const  toMonth = dateTo?.toDate?.().getMonth() -(-1);
        let params = {
            count: 200,
            page: 1,
            list: 1,
            returned: 1,
            orderBy: 'created_at',
            orderType: 'desc',
            processFor: 'Sales',
            status_id:  status,
            vendor_id: selectedOptions?.value,
            date_from: typeof dateFrom?.toDate?.().getFullYear() !== "undefined" ? dateFrom?.toDate?.().getFullYear() + '-' + fromMonth + '-' +dateFrom?.toDate?.().getDate() + ' 00:00' : '',
            date_to: typeof dateTo?.toDate?.().getFullYear() !== "undefined" ? dateTo?.toDate?.().getFullYear() + '-' + toMonth + '-' + dateTo?.toDate?.().getDate() + ' 23:59': '',
        }

        API.getOrders(params)
            .then((response) => {
                setOrders(response.data);
                setIsLoaded(true)
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });


        if(!selectOptions.length) {

        API.getVendors(params)
            .then((response) => {

                const vendors = response.data;
                let options = [];
                for (let data in vendors) {

                    options.push({
                        value: vendors[data].id,
                        label: vendors[data].title + " - " + vendors[data].city,
                    })
                }
                setSelectOptions(options)


            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

        }
    }, [status, selectedOptions, dateFrom, dateTo, selectOptions]);



    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header/>
            <Navbar page="returns"/>

            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <RiListCheck3 className='ms-2' />
همه                        سفارش ها
                    </h1>
                    {/*   <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                            <li className="breadcrumb-item">Pages</li>
                            <li className="breadcrumb-item active">Blank</li>
                        </ol>
                    </nav>*/}
                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-12">

                            <div className="card">
                                <div className="card-body pt-4 table-responsive">
                                    <div className="row filter-box mb-5 pb-2 rounded">

                                        <div className="col-md-4  pt-2">
                                            <Select
                                                options={selectOptions}
                                                placeholder="فیلتر بر اساس نماینده"
                                                value={selectedOptions}

                                                isSearchable={true}
                                                onChange={
                                                    (event) => {
                                                        setSelectedOptions(event)
                                                    }
                                                }
                                            />
                                        </div>
                                        <div className="col-md-4  text-start pt-2">
                                        <span className='float-end mt-2'>
                                            از تاریخ:
                                        </span>
                                            <DatePicker

                                                onChange={ (val) => setDateFrom(val) }
                                                calendar={persian}
                                                locale={persian_fa}
                                                calendarPosition= "bottom-right"
                                                className="rmdp-mobile"
                                                //value={this.state.date_from}

                                            />

                                        </div>
                                        <div className="col-md-4 pt-2 text-start">
                                        <span className='float-end mt-2'>
                                            تا تاریخ:
                                        </span>
                                            <DatePicker
                                                //value={this.state.date_to}
                                                onChange={ (val) => setDateTo(val) }
                                                calendar={persian}
                                                locale={persian_fa}
                                                calendarPosition= "bottom-right"
                                                className="rmdp-mobile"

                                            />
                                        </div>


                                    </div>


                                    <table className="table ">
                                        <thead>
                                        <tr className='text-small-2 text-muted'>
                                            <th scope="col"># </th>
                                            <th scope="col">نماینده</th>
                                            <th scope="col">تعداد باتری</th>
                                            <th scope="col">کد سفارش</th>
                                            <th scope="col">تاریخ ثبت</th>
                                            <th scope="col">وضعیت</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            orders.map (order => {
                                                return (
                                                    <tr  key={order.id}
                                                         role='button'
                                                         onClick={() => navigate(`/return-orders/${order.id}`)}
                                                    >
                                                        <th scope="row">
                                                            {order.factor_number}
                                                        </th>
                                                        <td>
                                                            {order.vendor?.title}
                                                            &nbsp;
                                                            <span
                                                                className='text-small-2 text-muted'>({order.vendor?.city})</span>
                                                        </td>
                                                        <td>
                                                            {order.battery_qty}
                                                        </td>
                                                        <td>
                                                            {order.tracking_code}
                                                        </td>
                                                        <td className='text-small-2' >
                                                            {order.date}
                                                        </td>



                                                        <td
                                                            style={{color:order.last_status?.color}}
                                                            className='text-small-2'
                                                        >
                                                            {order.last_status?.title}
                                                        </td>
                                                    </tr>
                                                )} )
                                        }
                                        </tbody>
                                    </table>


                                </div>
                            </div>

                        </div>



                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default ReturnOrders;